import {
  AppBar,
  Box,
  Container,
  Toolbar,
  Typography,
  useTheme,
} from '@mui/material'
import { FC } from 'react'
import { useRecoilValue } from 'recoil'
import { gymState } from '../../store/gym'

const Header: FC = () => {
  const theme = useTheme()
  const gym = useRecoilValue(gymState)

  return (
    <>
      <AppBar>
        <Container>
          <Toolbar>
            <Box
              component="img"
              src={gym?.gym_logo}
              alt={gym?.name}
              sx={{ maxBlockSize: theme.spacing(6) }}
            />
            <Typography variant="h2">{gym?.name}</Typography>
          </Toolbar>
        </Container>
      </AppBar>
      <Toolbar />
    </>
  )
}

export { Header }
